export default "__VITE_ASSET__CXL9k2zm__"